import React from "react";
import * as DateHelper from "../utils/date.formatter";
export default props => {
  return (
    <div key={props.key}>
      <img
        className="map-pin"
        src="/pin.png"
        lat={props.latitude}
        lng={props.longitude}
      />
      {/*{DateHelper.shortenDate(props.time)}*/}
    </div>
  );
};
